var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center justify-between w-full" },
    [
      _vm.isEdittingLocked
        ? _c("UiButton", {
            attrs: { buttonText: _vm.buttonText, size: "lg" },
            on: { click: _vm.handleEditClick },
          })
        : _vm._e(),
      _vm.isLinkObjectValid
        ? _c("RouterLink", { attrs: { to: _vm.linkObject } }, [
            _c(
              "span",
              {
                staticClass:
                  "text-lg text-primary underline hover:no-underline hover:text-primary-700",
              },
              [_vm._v(" " + _vm._s(_vm.linkText) + " ")]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }